export const storeFronts = {
	mybikeplan: "MyBikePlan",
	mysofaplan: "MyHomePlan"
}
